import {
  FormControlLabel,
  Grid,
  Radio,
  Switch,
  RadioGroup,
  Button,
  IconButton,
  InputAdornment,
} from "@mui/material";
import RemoveCircleIcon from "@mui/icons-material/RemoveCircleOutline";
import { Field, FieldArray, FieldArrayRenderProps } from "formik";
import FormikTextField from "../../../../components/common/formikFields/FormikTextField";
import {
  UpdatePeakSurchargeUIRequest,
  UpdateRouteRateUIRequest,
} from "./UpdateRouteRateModal";
import DatePicker from "react-multi-date-picker";
import { useRef } from "react";
import EventIcon from '@mui/icons-material/Event';


interface Props {
  values: UpdateRouteRateUIRequest;
  handleChange: any;
  handleBlur: any;
  setFieldValue: any;
}

const PeakSurcharge = (props: Props) => {
  const { values, handleChange, handleBlur, setFieldValue } = props;

  const ArrayHelperRef = useRef<FieldArrayRenderProps>();



  const isDisabledDate = (
    date: Date,
    peakSurcharges: UpdatePeakSurchargeUIRequest[]
  ) => {
    let isDisabled = false;
    peakSurcharges &&
      peakSurcharges.length > 0 &&
      peakSurcharges.every((surcharge) => {
        if (
          surcharge.peak_surcharge_date_range &&
          surcharge.peak_surcharge_date_range.length >= 2 &&
          surcharge.peak_surcharge_date_range[0] &&
          surcharge.peak_surcharge_date_range[1]
        ) {
          const minDate = surcharge.peak_surcharge_date_range[0].toDate();
          const maxDate = surcharge.peak_surcharge_date_range[1].toDate();

          date.setHours(0, 0, 0, 0);
          minDate.setHours(0, 0, 0, 0);
          maxDate.setHours(0, 0, 0, 0);

          if (date >= minDate && date <= maxDate) {
            isDisabled = true;
            return false;
          }
          return true;
        }
      });
    return isDisabled;
  };

  return (
    <>
      <Grid container alignItems={"center"}>
        <Grid item xs={12}>
          <FormControlLabel
            id="show_peak_surcharge"
            name="show_peak_surcharge"
            label="Peak Surcharge"
            labelPlacement="start"
            checked={values.show_peak_surcharge}
            control={
              <Field
                id="show_peak_surcharge"
                name="show_peak_surcharge"
                component={Switch}
                type="checkbox"
               // size="small"
                onChange={handleChange}
                onBlur={handleBlur}
              />
            }
          />
        </Grid>
      </Grid>
      <Grid
        container
        item
        alignItems={"center"}
        columnSpacing={2}
        display={values.show_peak_surcharge ? "" : "none"}
      >
        <FieldArray
          name="peakSurcharge"
          render={(arrayHelpers) => {
            ArrayHelperRef.current = arrayHelpers;

            return values.peakSurcharge.map((peakSurcharge, index) => (
              <>
                <Grid item>
    <IconButton
          sx={{
            color: 'gray', // Change color as needed
            fontSize: '1.5rem', // Increase icon size
            padding: '0.5rem', // Adjust padding if needed
          }}
    >
      <EventIcon /> {/* Replace with any icon you prefer */}
    </IconButton>
  </Grid>
               <Grid item xs={12} sm={2} md={3}>
                  <DatePicker
                    id={`peakSurcharge.${index}.peak_surcharge_date_range`}
                    name={`peakSurcharge.${index}.peak_surcharge_date_range`}
                    format="MM/DD/YYYY"
                    className="green"
                    dateSeparator=" ~ "
                    style={{ height: "36px" }}
                    value={peakSurcharge.peak_surcharge_date_range && peakSurcharge.peak_surcharge_date_range.length > 0 ? peakSurcharge.peak_surcharge_date_range : []}
                    onChange={(value) => {
                      setFieldValue(
                        `peakSurcharge.${index}.peak_surcharge_date_range`,
                        value
                      );
                    }}
                    range
                    rangeHover
                    mapDays={({ date }) => {
                      let props: any = {};
                      if (isDisabledDate(date.toDate(), values.peakSurcharge)) {
                        props.disabled = true;
                        props.style = { color: "gray", pointerEvents: "none" };
                      }
                      return props;
                    }}
                  />
                </Grid>
                <Grid item xs={10} sm={9} md={8}>
                  <RadioGroup
                    row
                    id={`peakSurcharge.${index}.peakSurchargeType`}
                    name={`peakSurcharge.${index}.peakSurchargeType`}
                    value={peakSurcharge.peakSurchargeType}
                    onChange={(e) => {
                      handleChange(e);
                      const selectedType = e.target.value;
                      if (selectedType === "percentage") {
                        setFieldValue(
                          `peakSurcharge.${index}.peak_surcharge_value_dollar`,
                          ""
                        );
                      } else if (selectedType === "value") {
                        setFieldValue(
                          `peakSurcharge.${index}.peak_surcharge_value_percentage`,
                          ""
                        );
                      }
                    }}
                    onBlur={handleBlur}
                  >
                    {/* Percentage Input */}
                    <FormControlLabel
                      control={<Radio />}
                      value="percentage"
                      label={
                        <FormikTextField
                          id={`peakSurcharge.${index}.peak_surcharge_value_percentage`}
                          name={`peakSurcharge.${index}.peak_surcharge_value_percentage`}
                          variant="outlined"
                          size="small"
                          label=""
                          disabled={
                            peakSurcharge.peakSurchargeType !== "percentage"
                          }
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">%</InputAdornment>
                            ),
                          }}
                        />
                      }
                    />
                    {/* Dollar Value Input */}
                    <FormControlLabel
                      control={<Radio />}
                      value="value"
                      label={
                        <FormikTextField
                          variant="outlined"
                          id={`peakSurcharge.${index}.peak_surcharge_value_dollar`}
                          name={`peakSurcharge.${index}.peak_surcharge_value_dollar`}
                          size="small"
                          label=""
                          disabled={peakSurcharge.peakSurchargeType !== "value"}
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">$</InputAdornment>
                            ),
                          }}
                        />
                      }
                    />
                  </RadioGroup>
                </Grid>
                <Grid item xs={2} sm={1} md={1}>
                  <IconButton
                    color="error"
                    onClick={() => {
                      arrayHelpers.remove(index);
                    }}
                  >
                    <RemoveCircleIcon />
                  </IconButton>
                </Grid>
              </>
            ));
          }}
        />
        <Grid item mt={2}>
          <Button
            variant="contained"
            onClick={() => {
              ArrayHelperRef.current?.push({
                peakSurchargeType: "percentage",
                peak_surcharge_value_percentage: "",
                peak_surcharge_value_dollar: "",
                peak_surcharge_date_range: [],
              });
            }}
          >
            Add
          </Button>
        </Grid>
      </Grid>
    </>
  );
};

export default PeakSurcharge;
